import address, { type AddressState } from './address/address.reducer';
import auth, { type AuthState } from './auth/auth.reducer';
import automations, { type AutomationsState } from './automations/automations.reducer';
import batchEntry, { type BatchEntryState } from './batch-entry/batch-entry.reducer';
import billing, { type BillingState } from './billing/billing.reducer';
import branding, { type BrandingState } from './branding/branding.reducer';
import carrierAccounts, {
  type CarrierAccountsState,
} from './carrier-accounts/carrier-accounts.reducer';
import carrierFormFields, {
  type CarrierFormFieldsState,
} from './carrier-form-fields/carrier-form-fields.reducer';
import csvImport, { type CSVState } from './csv-import/csv-import.reducer';
import dialog, { type DialogState } from './dialog/dialog.reducer';
import featureTests, { type FeatureTestsState } from './feature-tests/feature-tests.reducer';
import filters, { type FiltersState } from './filters/filters.reducer';
import help, { type HelpState } from './help/help.reducer';
import labelSettings, { type LabelSettingsState } from './label-settings/labels.settings.reducer';
import lineItem, { type LineItemState } from './line-item/line-item.reducer';
import manifests, { type ManifestsState } from './manifests/manifests.reducer';
import manualOrder, { type ManualOrderState } from './manual-order/manual-order.reducer';
import notifications, { type NotificationsState } from './notifications/notifications.reducer';
import orders, { type OrdersState } from './orders/orders.reducer';
import ordersBatch, { type OrdersBatchState } from './orders-batch/orders-batch.reducer';
import packages, { type PackagesState } from './packages/packages.reducer';
import pickups, { type PickupsState } from './pickups/pickups.reducer';
import plans, { type PlansState } from './plans/plans.reducer';
import promos, { type PromosState } from './promos/promos.reducer';
import providers, { type ProvidersState } from './providers/providers.reducer';
import rates, { type RatesState } from './rates/rates.reducer';
import ratesAtCheckout, {
  type RatesAtCheckoutState,
} from './rates-at-checkout/rates-at-checkout.reducer';
import shipments, { type ShipmentsState } from './shipments/shipments.reducer';
import snackbar, { type SnackbarState } from './snackbar/snackbar.reducer';
import stores, { type StoresState } from './stores/stores.reducer';
import trackingSettings, {
  type TrackingSettingsState,
} from './tracking-settings/tracking-settings.reducer';
import transactions, { type TransactionsState } from './transactions/transactions.reducer';
import user, { type UserState } from './user/user.reducer';

export default {
  address,
  auth,
  automations,
  batchEntry,
  billing,
  branding,
  carrierAccounts,
  carrierFormFields,
  csvImport,
  dialog,
  featureTests,
  filters,
  help,
  labelSettings,
  lineItem,
  manifests,
  manualOrder,
  notifications,
  orders,
  ordersBatch,
  packages,
  pickups,
  plans,
  promos,
  providers,
  rates,
  ratesAtCheckout,
  shipments,
  snackbar,
  stores,
  trackingSettings,
  transactions,
  user,
};

export interface Reducers {
  address: AddressState;
  auth: AuthState;
  automations: AutomationsState;
  batchEntry: BatchEntryState;
  billing: BillingState;
  branding: BrandingState;
  carrierAccounts: CarrierAccountsState;
  carrierFormFields: CarrierFormFieldsState;
  csvImport: CSVState;
  dialog: DialogState;
  featureTests: FeatureTestsState;
  filters: FiltersState;
  help: HelpState;
  labelSettings: LabelSettingsState;
  lineItem: LineItemState;
  manifests: ManifestsState;
  manualOrder: ManualOrderState;
  notifications: NotificationsState;
  orders: OrdersState;
  ordersBatch: OrdersBatchState;
  packages: PackagesState;
  pickups: PickupsState;
  plans: PlansState;
  promos: PromosState;
  providers: ProvidersState;
  rates: RatesState;
  ratesAtCheckout: RatesAtCheckoutState;
  shipments: ShipmentsState;
  snackbar: SnackbarState;
  stores: StoresState;
  trackingSettings: TrackingSettingsState;
  transactions: TransactionsState;
  user: UserState;
}
